import styled from 'styled-components';
import { Modal as ShellModal } from 'src/UI/Modal';

export const Modal = styled(ShellModal)`
  .button-style {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
  }

  .country-name input {
    text-transform: uppercase;
  }
  .shell-modal-container-title {
    .shell-text-label {
      font-size: 14px;
    }
  }
  .group-details {
    margin-bottom: 12px;
  }
  .group-details-with-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .param-title {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const SystemAdminContainer = styled.div`
  padding: 5px 15px 10px;
  .shell-tabs-extra-content {
    display: flex;
    align-items: center;
    margin-left: 16px;
    flex-shrink: 0;
  }
  .master-data-download {
    white-space: nowrap;
    &:disabled {
      background-color: ${(props) => props.theme.background.inactive};
      color: ${(props) => props.theme.text.onSurface.inactive};
    }
  }
  .master-data-download-secondary {
    width: 32px;
    min-width: 32px;
    height: 32px;
    padding: 0;
    color: ${(props) => props.theme.text.onSurface.strong};
    background-color: ${(props) => props.theme.background.section};
    border-color: ${(props) => props.theme.border.medium};
    &:hover:not(:disabled) {
      background-color: ${(props) => props.theme.focus.extraSubtle};
    }
  }
  .action-container {
    flex-wrap: wrap;
  }
  .shell-tabs .shell-tabs-nav {
    margin-bottom: 10px;
    border-bottom: 1px solid ${(props) => props.theme.border.medium};
  }
  .shell-tabs-nav-wrap {
    flex: 1;
    min-width: 0;
    .shell-tabs-tab {
      .shell-tabs-tab-btn {
        padding: 9px 8px;
      }
    }
  }
`;
